import { fg } from '@atlassian/jira-feature-gating';
import {
	QUERY_PARAM_SORT_BY,
	QUERY_PARAM_SORT_ORDER,
} from '@atlassian/jira-software-releases-version-detail-issue-list-query-param-controller/src/controllers/filter-sorting-query-param/constants.tsx';
import { useFilterSortingQueryParams } from '@atlassian/jira-software-releases-version-detail-issue-list-query-param-controller/src/controllers/filter-sorting-query-param/index.tsx';
import messages from './messages.tsx';
import type { SortByFieldOption, SortOrderOption } from './types.tsx';

export const sortOrderOptions: SortOrderOption[] = [
	{ id: 'ASC', label: messages.ascending },
	{ id: 'DESC', label: messages.descending },
];

export const sortByFieldOptions: SortByFieldOption[] = [
	{ id: 'CREATED', label: messages.sortByDateCreated },
	{ id: 'ASSIGNEE', label: messages.sortByAssignee },
	{
		id: 'KEY',
		label: messages.sortByIssueKeyIssueTerminologyRefreshM4,
	},
	{ id: 'PRIORITY', label: messages.sortByPriority },
	{ id: 'STATUS', label: messages.sortByIssueStatusCategory },
	{ id: 'TYPE', label: messages.sortByIssueType },
];

export const sortByFieldOptionsOld: SortByFieldOption[] = [
	{ id: 'CREATED', label: messages.sortByDateCreated },
	{ id: 'ASSIGNEE', label: messages.sortByAssignee },
	{
		id: 'KEY',
		label: messages.sortByIssueKey,
	},
	{ id: 'PRIORITY', label: messages.sortByPriority },
	{ id: 'STATUS', label: messages.sortByIssueStatusCategory },
	{ id: 'TYPE', label: messages.sortByIssueType },
];

export const useCurrentSortOptions = () => {
	const { parsedQueryParams } = useFilterSortingQueryParams();

	const fieldOptions = fg('jira-issue-terminology-update-m4')
		? sortByFieldOptions
		: sortByFieldOptionsOld;
	const currentSortByOption =
		fieldOptions.find((option) => option.id === parsedQueryParams[QUERY_PARAM_SORT_BY]) ??
		fieldOptions[0];
	const currentSortOrderOption =
		sortOrderOptions.find((option) => option.id === parsedQueryParams[QUERY_PARAM_SORT_ORDER]) ??
		sortOrderOptions[0];

	return {
		currentSortByOption,
		currentSortOrderOption,
	};
};
